module.exports = __webpack_public_path__ + "img/phone-outgoing-02.491219db.svg";